import styled from "styled-components";

const FilterProductType = styled.ul`
  --svg-size: 20px;
  font-family: var(--font-DINNextLTPro-Regular);

  .filter-product-type__header {
    display: flex;
    align-items: baseline;
  }

  .filter-product-type__heading {
    color: ${({theme}) => theme.colors.brand};
  }

  .filter-product-type__clear {
    margin-left: auto;
    color: ${({theme}) => theme.colors.brand};

    &:hover,
    &:focus {
      color: ${({theme}) => theme.colors.brand};
    }
  }

  .filter-product-type__show {
    margin-top: .875rem;
    flex: 1 1 100%;

    @media (max-width: 859px) {
      margin-left: .5rem;
    }
  }

  .filter-product-type__show-button {
    padding: 4px 8px;
    border: 3px solid ${({theme}) => theme.colors.brand};
    border-radius: 16px;
    color: ${({theme}) => theme.colors.brand};
    outline: none;

    &:hover,
    &:focus {
      border-color: ${({theme}) => theme.colors.brand};
      color: ${({theme}) => theme.colors.brand};
    }
  }

  .filter-product-type__add {
    margin-left: auto;
    width: 16px;
    height: 16px;
    stroke: ${({theme}) => theme.colors.brand};
    border: 2px solid ${({theme}) => theme.colors.brand};
    border-radius: 50%;
    display: inline-flex;
    justify-content: center;
    align-items: center;

    &:hover,
    &:focus {
      border-color: ${({theme}) => theme.colors.brand};
      background-color: ${({theme}) => theme.colors.brand};
      stroke: ${({theme}) => theme.colors.white};
    }

    svg {
      width: 10px;
      height: 10px;
      stroke: inherit;
    }
  }

  .filter-product-type__type {
    width: 100%;
    display: inline-flex;
    align-content: center;
    flex-direction: column;

    &:hover {
      color: ${({theme}) => theme.colors.bundleGold};
      svg.filter-check-square__not-checked {
        border: 2px solid ${({ theme }) => theme.colors.bundleGold};
        rect {
          stroke: ${({theme}) => theme.colors.bundleGold};
        }
      }      
    }

    @media (max-width: 859px) {
      &:not(:first-of-type) {
        margin-top: .75rem;
      }
    }
    @media (min-width: 860px) {
      &:not(:first-child) {
        margin-top: .75rem;
      }
    }
  }
  .filter-product-type__sub-category {
    margin-left: 15px;
    li {
      margin-top: .75rem;
    }
  }

  .filter-product-type__checkbox {
    padding-top: .125rem;
    padding-bottom: .125rem;
    display: inline-flex;
    align-items: center;
    flex-shrink: 0;
    position: relative;
    cursor: pointer;
    transition: var(--button-transition);

    input {
      position: absolute;
      opacity: 0;
      cursor: pointer;
    }
  }

  .filter-product-type__checkbox__custom {
    position: relative;
    height: 14px;
    width: 14px;
    flex-shrink: 0;
  };

  .filter-check-arrow {
    position: absolute;
    top: -9px;
    left: -3px;
    width: 23px;
    height: 23px;
  };

  .filter-check-square {
    width: 16px;
    height: 16px;
    border: 2px solid ${({ theme }) => theme.colors.brand};
    border-radius: 5px;
  };

  .filter-check-square__not-checked {
    width: 16px;
    height: 16px;
    border: 2px solid ${({ theme }) => theme.colors.bundleWhite};
    border-radius: 5px;
  };

  .filter-product-type__checkbox__copy {
    margin-left: 8px;
    font-family: var(--font-DINNextLTPro-Regular);
  };

  .input-search {
    height: 36px;
    display: flex;
    border-bottom: 3px solid ${({ theme }) => theme.colors.brand};
    
    @media (min-width: 860px) {
      margin-top: 1rem;
    }
  }

  .input-search__input {
    width: 192px;
    padding-top: 10px;
    padding-bottom: 10px;
    border-right: none;
    background-color: transparent;
    color: ${({ theme }) => theme.colors.brand};
    border: none;
    outline: none;

    @media (max-width: 859px) {
      width: 100%;
    }

    &::placeholder {
      color: ${({ theme }) => theme.colors.brand}
    }

    &:hover,
    &:focus {
      border-color: ${({ theme }) => theme.colors.brand}
    }
  }

  .input-search__icon {
    width: 38px;
    flex-shrink: 0;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    border-right: none;
    border-radius: 16px 0 0 16px;

    svg {
      width: 16px;
      height: 16px;
      box-sizing: content-box;
      fill: inherit;
    }
  }

  .input-search__button {
    width: 32px;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    flex-shrink: 0;
    background-color: transparent;
    fill: ${({theme}) => theme.colors.black};
    transition: var(--button-transition);

    &:hover,
    &:focus {
      fill: ${({ theme }) => theme.colors.brand};
    }

    svg {
      width: 12px;
      height: 12px;
      box-sizing: content-box;
      fill: ${({ theme }) => theme.colors.brand};
    }
  }
`;

export default FilterProductType;